import req from "../methods/req"
import method from '../methods/method'

// 获取地区列表
export const getRegion = function (data) {
	return req({
		url: '/manage/crm.common/getRegion',
		...data
	})
}


// 获取地区列表
export const getUploadOSSConfig = function (data) {
	return req({
		url: '/manage/crm.common/upload',
		...data
	})
}